import { Component, OnInit } from '@angular/core';
import { ActivationEnd, Router } from '@angular/router';
import { LoginDataService } from 'src/app/data-repositories/login-data.service';
import { AuthService } from 'src/app/repositories/auth.service';

@Component({
  standalone: false,
  selector: 'app-edit-user',
  templateUrl: './edit-user.component.html',
  styleUrls: ['./edit-user.component.scss']
})
export class EditUserComponent implements OnInit {

  constructor(public router: Router, private loginService: LoginDataService, private authService: AuthService) {
    this.router.events.subscribe(event => {
      if (event instanceof ActivationEnd) {
        if (event.snapshot.queryParams.key) {
          const key = event.snapshot.queryParams.key;

          loginService.editUser(key, user => {
            if (user.accessToken) {
              this.authService.setUserStatus(user, true);
              this.authService.loginEditbleUer(user);
            }
          });
        }
      }
    });
  }

  ngOnInit() {
  }

}
